<template>
  <span class="inline-flex items-center rounded-md bg-context/8 px2 py1 text-context fw600 ring-1 ring-context/15 ring-inset dark:bg-context/12">
    <slot />
  </span>
</template>
